import Button from '@components/button';
import { EVisitsFeedItem } from '@components/e-visits';
import { getDateFormat } from '@helpers/utils-helpers';
import useDailyEvents from '@hooks/query/calendar/useDailyEvents';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import FeedCardHeader from './feed-card-header';
import FeedIcon from './feed-icon';
import { FeedEVisitsSC } from './feed.styled';

const FeedEVisit = () => {
  const { push } = useHistory();
  const [showAll, setShowAll] = React.useState(false);

  const { data: events } = useDailyEvents(undefined, { refetchInterval: 60000 });

  const mappedEvents = React.useMemo(() => {
    let bookedFree = 0;
    let bookedPremium = 0;

    if (events) {
      for (const event of events) {
        if (event.tag && event.tag.price !== '0.00') {
          bookedPremium += 1;
        } else {
          bookedFree += 1;
        }
      }
    }

    return {
      booked: events,
      bookedFree,
      bookedPremium,
    };
  }, [events]);

  return (
    <FeedEVisitsSC className="feed-card">
      {/* <FeedIcon>
        <img
          src={require('@assets/svg/icon-evisit_dark.svg').default}
          width="24"
          height="19"
          alt=""
        />
      </FeedIcon> */}
      <FeedCardHeader
        title={<FormattedMessage id="feedEVisit_title" />}
        onClick={() => {
          push('/e-visits/calendar');
        }}
      >
        <div className="header">
          <time className="fch-time">{moment().format(getDateFormat())}</time>
          <div className="stats">
            <div className="item">
              <div className="indicator free"></div>
              {mappedEvents.bookedFree}
            </div>
            <div className="item">
              <div className="indicator premium"></div>
              {mappedEvents.bookedPremium}
            </div>
            {/* <div className="item">
              <div className="indicator not-booked"></div>
              {mappedEvents.free.length}
            </div> */}
          </div>
        </div>
      </FeedCardHeader>
      <div className="items">
        {mappedEvents.booked?.length === 0 ? (
          <div className="empty">
            <div className="icon">
              <img
                src={require('@assets/svg/icon-evisit_dark.svg').default}
                alt=""
                width="16"
                height="16"
              />
            </div>
            <h3>
              <FormattedMessage id="feedEVisit_empty_title" />
            </h3>
            <p>
              <FormattedMessage id="feedEVisit_empty_description" />
            </p>
          </div>
        ) : (
          (showAll ? mappedEvents.booked : mappedEvents.booked?.slice(0, 3))?.map((e) => (
            <EVisitsFeedItem event={e} key={`${e.from}-${e.to}`} />
          ))
        )}
        {mappedEvents.booked && mappedEvents.booked?.length > 3 && (
          <Button
            onClick={() => {
              setShowAll((o) => !o);
            }}
            isBlock
            size="NM"
          >
            {showAll ? (
              <FormattedMessage id="feedEVisit_show_less" />
            ) : (
              <FormattedMessage id="feedEVisit_show_more" />
            )}
          </Button>
        )}
      </div>
    </FeedEVisitsSC>
  );
};

export default React.memo(FeedEVisit);
